import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { configState } from '../plugins/config';

dayjs.extend(utc);
dayjs.extend(timezone);

export const utcToLocalTime = (
	utcDate: string,
	format = 'YYYY-MM-DD HH:mm:ss'
) => {
	const isZulufTime = utcDate.includes('Z');

	if (!isZulufTime) {
		return utcDate;
	}

	const tz =
		configState.meta.timezone ||
		Intl.DateTimeFormat().resolvedOptions().timeZone;

	const localTime = dayjs(utcDate).tz(tz).format(format);

	return localTime;
};
